// extracted by mini-css-extract-plugin
module.exports = {"accordion_trigger":"Accordion_accordion_trigger__b_8p6","accordion_container":"Accordion_accordion_container__0y5MM","accordion_item":"Accordion_accordion_item__T6kWy"};